module.exports = __webpack_public_path__ + "media/images/billing/ava-successful-3310081ee419f82b713bd276ff75f246.svg";